// Bilingual translations: ES (español) and GL (galego)
export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      academy: "Academia",
      diy: "Faino ti",
      contact: "Contacto",
      askGerardo: "Preguntar a Gerardo",
    },
    hero: {
      eyebrow: "Desde 2007 en Galicia",
      titleA: "Reformas, fontanería y",
      titleB: "electricidad.",
      titleC: "Ahora también, aprende a hacerlo tú mismo.",
      subtitle:
        "Desde 2007 en Galicia. Y muy pronto llega la Academia Homeatope con su «Curso Manitas»: 25 clases con sus tutoriales para que tomes el control del mantenimiento de tu hogar.",
      comingSoonPill: "Curso Manitas · Próximamente",
      ctaPrimary: "Pedir presupuesto",
      ctaSecondary: "Hablar con Gerardo IA",
      stat1: "Más de 25 años de oficio",
      stat2: "Más de 10.000 hogares atendidos",
      stat3: "Proveedores locales",
    },
    about: {
      eyebrow: "Quién está detrás",
      title: "Gerardo Salvo",
      role: "Fundador · Fontanero y Electricista certificado",
      body:
        "Uruguayo, comenzó a trabajar en el sector de la construcción cuando emigró a España en 2000. Desde 2007 en Galicia. Trabaja con proveedores de cercanía, como Ferrecal, Bricomat, Saltoki y Calefón.",
      reviewsTitle: "180 reseñas en Google",
      reviewsSubtitle: "Valoración media 4,7 ★",
      reviewsCta: "Ver reseñas en Google Maps",
    },
    services: {
      eyebrow: "Servicios profesionales",
      title: "Lo que resolvemos en tu casa",
      subtitle:
        "Trabajo limpio, presupuestos claros y materiales de confianza. Atendemos urgencias y planificamos mini reformas.",
      disclaimer:
        "* No trabajo en gas ni reparación de calderas. No expido boletines.",
      items: [
        {
          key: "urgencias",
          title: "Urgencias 24/6",
          desc:
            "Fontanería y electricidad de urgencia 24 horas, de lunes a sábado. Los domingos no atendemos urgencias.",
        },
        {
          key: "plumbing",
          title: "Fontanería",
          desc:
            "Instalación y reparaciones de Agua corriente sanitaria, desagües, termos eléctricos, calefacción y desatascos.",
        },
        {
          key: "electric",
          title: "Electricidad",
          desc:
            "Averías comunes, cuadros eléctricos e instalaciones.",
        },
        {
          key: "remod",
          title: "Reformas y manitas",
          desc:
            "Pequeñas reformas, cocinas y baños.",
        },
      ],
    },
    academy: {
      eyebrow: "Academia de Mantenimiento",
      title: "Curso Manitas",
      tagline: "«La autonomía en el hogar no es un lujo, es una maestría necesaria. Gerardo te enseña el camino del Oficial.»",
      subtitle:
        "25 clases en vídeo, paso a paso, para que tomes el control del mantenimiento de tu hogar. Pregúntale a nuestro asistente Gerardo IA cualquier duda del temario.",
      comingSoonBadge: "Próximamente",
      comingSoonNotice:
        "Estamos ultimando el lanzamiento. Reserva ya tu plaza y te avisamos apenas se abra la matrícula.",
      ctaPrimary: "Apúntame a la lista de espera",
      ctaSecondary: "Hablar con Gerardo IA",
      curriculumTitle: "Temario del Curso Manitas",
      curriculumSubtitle: "25 clases · 6 bloques temáticos",
      modules: [
        { key: "b1", title: "Bloque 1 · Fundamentos y preparación", items: ["01 · Introducción y filosofía del Manitas", "02 · Herramientas básicas", "03 · Planos y documentación", "04 · Seguridad: llaves de corte", "05 · Detectar cables ocultos"] },
        { key: "b2", title: "Bloque 2 · Fontanería", items: ["06 · Fontanería básica: llaves y tuberías", "07 · Cambio de latiguillo y teflón", "08 · Cisternas y grifos", "09 · Lavadora y termo", "10 · Desatascar tuberías"] },
        { key: "b3", title: "Bloque 3 · Electricidad", items: ["11 · Conceptos eléctricos fundamentales", "12 · Derivación a tierra: ¿por qué salta?", "13 · Lámparas y enchufes", "14 · Mantenimiento del frigorífico", "15 · Cortocircuitos y consumo"] },
        { key: "b4", title: "Bloque 4 · Mantenimiento y eficiencia", items: ["16 · Presión de la caldera", "17 · Seguridad en instalación de gas", "18 · Aislamiento y eficiencia"] },
        { key: "b5", title: "Bloque 5 · Reparaciones y acabados", items: ["19 · Reparar azulejos", "20 · Técnicas de pintura", "21 · Cambiar el bombín", "22 · Estanterías y muebles"] },
        { key: "b6", title: "Bloque 6 · Legalidad y cierre", items: ["23 · Certificaciones profesionales", "24 · Seguros de hogar y negociación", "25 · Estado de latiguillos y cierre"] },
      ],
      pdfTitle: "Descarga el temario completo",
      pdfSubtitle: "Las 25 clases con el detalle de cada tema. Déjanos tu email y te avisamos cuando abramos matrícula.",
      pdfEmailPlaceholder: "tu@email.com",
      pdfCta: "Descargar PDF gratis",
      pdfSending: "Enviando…",
      pdfSuccess: "¡Listo! Descargando el temario. Te avisaremos al abrir matrícula.",
      pdfError: "No se pudo procesar. Revisa el email o inténtalo de nuevo.",
      chatTitle: "Habla con Gerardo IA",
      chatSubtitle: "Asistente con IA · respuestas en segundos",
      chatPlaceholder: "Pregúntale algo: «¿Cómo purgo un radiador?»",
      chatSend: "Enviar",
      chatThinking: "Gerardo está escribiendo…",
      chatFirstHi:
        "¡Hola! Soy Gerardo. ¿Tienes alguna duda sobre fontanería, electricidad o quieres saber sobre la inscripción al Curso Manitas?",
      chatErrorFallback:
        "Vaya, no pude conectar ahora. Prueba en unos segundos o escríbenos a WhatsApp 669 024 616.",
      whatsappCta: "Matricularme por WhatsApp",
    },
    diy: {
      eyebrow: "Faino ti / Hazlo tú mismo",
      title: "Visita nuestro blog histórico",
      subtitle:
        "Nuestro blog histórico está lleno de guías paso a paso, recomendaciones de herramientas de confianza y trucos del oficio. Todo lo publicado por Gerardo desde hace años.",
      cta: "Ir al blog",
      blogUrl: "https://fontanerohomeatopelectricista.com",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cuéntanos qué necesitas",
      subtitle:
        "Servicio técnico o inscripción al curso: te respondemos en horas hábiles, sin compromiso.",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono (opcional)",
      topic: "Motivo",
      topicService: "Servicio técnico",
      topicCourse: "Curso Manitas",
      topicOther: "Otro",
      serviceType: "Tipo de servicio",
      msg: "Cuéntanos brevemente",
      send: "Enviar solicitud",
      sending: "Enviando…",
      successTitle: "¡Solicitud enviada!",
      successDesc: "Te respondemos lo antes posible. Si es urgente, escríbenos por WhatsApp.",
      errorTitle: "Ups, no se pudo enviar",
      errorDesc: "Inténtalo de nuevo o escríbenos por WhatsApp 669 024 616.",
      phoneDirect: "Llámanos directamente",
      whatsapp: "Chat por WhatsApp",
    },
    footer: {
      tagline: "Profesional, cercano y de Galicia.",
      tagline2:
        "Síguenos también en YouTube y en nuestro blog histórico. Escríbenos por WhatsApp para respuesta rápida.",
      followUs: "Síguenos",
      legal: "Aviso legal",
      privacy: "Privacidad",
      cookies: "Cookies",
      rights: "Todos los derechos reservados.",
    },
    theme: { light: "Modo claro", dark: "Modo oscuro" },
    lang: { es: "Español", gl: "Galego" },
  },
  gl: {
    nav: {
      home: "Inicio",
      services: "Servizos",
      academy: "Academia",
      diy: "Faino ti",
      contact: "Contacto",
      askGerardo: "Preguntar a Gerardo",
    },
    hero: {
      eyebrow: "Desde 2007 en Galicia",
      titleA: "Reformas, fontanería e",
      titleB: "electricidade.",
      titleC: "Agora tamén, aprende a facelo ti mesmo.",
      subtitle:
        "Desde 2007 en Galicia. E moi pronto chega a Academia Homeatope co seu «Curso Manitas»: 25 clases cos seus titoriais para que tomes o control do mantemento do teu fogar.",
      comingSoonPill: "Curso Manitas · Próximamente",
      ctaPrimary: "Pedir orzamento",
      ctaSecondary: "Falar con Gerardo IA",
      stat1: "Máis de 25 anos de oficio",
      stat2: "Máis de 10.000 fogares atendidos",
      stat3: "Provedores locais",
    },
    about: {
      eyebrow: "Quen está detrás",
      title: "Gerardo Salvo",
      role: "Fundador · Fontaneiro e Electricista certificado",
      body:
        "Uruguaio, comezou a traballar no sector da construción cando emigrou a España en 2000. Desde 2007 en Galicia. Traballa con provedores de proximidade, como Ferrecal, Bricomat e Saltoki.",
      reviewsTitle: "180 reseñas en Google",
      reviewsSubtitle: "Valoración media 4,7 ★",
      reviewsCta: "Ver reseñas en Google Maps",
    },
    services: {
      eyebrow: "Servizos profesionais",
      title: "O que resolvemos na túa casa",
      subtitle:
        "Traballo limpo, orzamentos claros e materiais de confianza. Atendemos urxencias e planificamos mini reformas.",
      disclaimer:
        "* Non traballo con gas nin reparación de caldeiras. Non expido boletíns.",
      items: [
        {
          key: "urgencias",
          title: "Urxencias 24/6",
          desc:
            "Fontanería e electricidade de urxencia 24 horas, de luns a sábado. Os domingos non atendemos urxencias.",
        },
        {
          key: "plumbing",
          title: "Fontanería",
          desc:
            "Instalación e reparacións de Auga corrente sanitaria, desaugadoiros, termos eléctricos, calefacción e desatascos.",
        },
        {
          key: "electric",
          title: "Electricidade",
          desc:
            "Avarías comúns, cadros eléctricos e instalacións.",
        },
        {
          key: "remod",
          title: "Reformas e manitas",
          desc:
            "Pequenas reformas, cociñas e baños.",
        },
      ],
    },
    academy: {
      eyebrow: "Academia de Mantemento",
      title: "Curso Manitas",
      tagline: "«A autonomía no fogar non é un luxo, é unha mestría necesaria. Gerardo ensínache o camiño do Oficial.»",
      subtitle:
        "25 clases en vídeo, paso a paso, para que tomes o control do mantemento do teu fogar. Pregúntalle ao noso asistente Gerardo IA calquera dúbida do temario.",
      comingSoonBadge: "Próximamente",
      comingSoonNotice:
        "Estamos a ultimar o lanzamento. Reserva xa a túa praza e avisámoste apenas se abra a matrícula.",
      ctaPrimary: "Apúntame á lista de espera",
      ctaSecondary: "Falar con Gerardo IA",
      curriculumTitle: "Temario do Curso Manitas",
      curriculumSubtitle: "25 clases · 6 bloques temáticos",
      modules: [
        { key: "b1", title: "Bloque 1 · Fundamentos e preparación", items: ["01 · Introdución e filosofía do Manitas", "02 · Ferramentas básicas", "03 · Planos e documentación", "04 · Seguridade: chaves de corte", "05 · Detectar cables ocultos"] },
        { key: "b2", title: "Bloque 2 · Fontanería", items: ["06 · Fontanería básica: chaves e tubaxes", "07 · Cambio de latiguillo e teflón", "08 · Cisternas e billas", "09 · Lavadora e termo", "10 · Desatascar tubaxes"] },
        { key: "b3", title: "Bloque 3 · Electricidade", items: ["11 · Conceptos eléctricos fundamentais", "12 · Derivación a terra: por que salta?", "13 · Lámpadas e enchufes", "14 · Mantemento do frigorífico", "15 · Curtocircuítos e consumo"] },
        { key: "b4", title: "Bloque 4 · Mantemento e eficiencia", items: ["16 · Presión da caldeira", "17 · Seguridade en instalación de gas", "18 · Illamento e eficiencia"] },
        { key: "b5", title: "Bloque 5 · Reparacións e acabados", items: ["19 · Reparar azulexos", "20 · Técnicas de pintura", "21 · Cambiar o bombín", "22 · Estanterías e mobles"] },
        { key: "b6", title: "Bloque 6 · Legalidade e peche", items: ["23 · Certificacións profesionais", "24 · Seguros de fogar e negociación", "25 · Estado de latiguillos e peche"] },
      ],
      pdfTitle: "Descarga o temario completo",
      pdfSubtitle: "As 25 clases co detalle de cada tema. Déixanos o teu email e avisámoste cando abramos matrícula.",
      pdfEmailPlaceholder: "o.teu@email.com",
      pdfCta: "Descargar PDF gratis",
      pdfSending: "Enviando…",
      pdfSuccess: "Listo! Descargando o temario. Avisarémoste ao abrir matrícula.",
      pdfError: "Non se puido procesar. Revisa o email ou téntao de novo.",
      chatTitle: "Fala con Gerardo IA",
      chatSubtitle: "Asistente con IA · respostas en segundos",
      chatPlaceholder: "Pregúntalle algo: «Como purgo un radiador?»",
      chatSend: "Enviar",
      chatThinking: "Gerardo está escribindo…",
      chatFirstHi:
        "Ola! Son Gerardo. Tes algunha dúbida sobre fontanería, electricidade ou queres saber sobre a inscrición ao Curso Manitas?",
      chatErrorFallback:
        "Vaia, non puiden conectar agora. Proba nuns segundos ou escríbenos a WhatsApp 669 024 616.",
      whatsappCta: "Matricularme por WhatsApp",
    },
    diy: {
      eyebrow: "Faino ti",
      title: "Visita o noso blog histórico",
      subtitle:
        "O noso blog histórico está cheo de guías paso a paso, recomendacións de ferramentas de confianza e trucos do oficio. Todo o publicado por Gerardo desde hai anos.",
      cta: "Ir ao blog",
      blogUrl: "https://fontanerohomeatopelectricista.com",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cóntanos o que necesitas",
      subtitle:
        "Servizo técnico ou inscrición ao curso: respondemos en horas hábiles, sen compromiso.",
      name: "Nome",
      email: "Email",
      phone: "Teléfono (opcional)",
      topic: "Motivo",
      topicService: "Servizo técnico",
      topicCourse: "Curso Manitas",
      topicOther: "Outro",
      serviceType: "Tipo de servizo",
      msg: "Cóntanos brevemente",
      send: "Enviar solicitude",
      sending: "Enviando…",
      successTitle: "Solicitude enviada!",
      successDesc: "Respondémosche o antes posible. Se é urxente, escríbenos por WhatsApp.",
      errorTitle: "Ups, non se puido enviar",
      errorDesc: "Inténtao de novo ou escríbenos por WhatsApp 669 024 616.",
      phoneDirect: "Chámanos directamente",
      whatsapp: "Chat por WhatsApp",
    },
    footer: {
      tagline: "Profesional, próximo e de Galicia.",
      tagline2:
        "Séguenos tamén en YouTube e no noso blog histórico. Escríbenos por WhatsApp para resposta rápida.",
      followUs: "Séguenos",
      legal: "Aviso legal",
      privacy: "Privacidade",
      cookies: "Cookies",
      rights: "Todos os dereitos reservados.",
    },
    theme: { light: "Modo claro", dark: "Modo escuro" },
    lang: { es: "Español", gl: "Galego" },
  },
};

export const SERVICE_KEYS = ["plumbing", "electric", "heating", "remod"];
